/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FirstAid(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M232,104v48a16.01833,16.01833,0,0,1-16,16H168v48a16.01833,16.01833,0,0,1-16,16H104a16.01833,16.01833,0,0,1-16-16V168H40a16.01833,16.01833,0,0,1-16-16V104A16.01833,16.01833,0,0,1,40,88H88V40a16.01833,16.01833,0,0,1,16-16h48a16.01833,16.01833,0,0,1,16,16V88h48A16.01833,16.01833,0,0,1,232,104Z" />
    </Svg>
  );
}

export default FirstAid;
